{
    "ReportPortalInfo_UpgradeTo_Enterprise": "Atualizar para Enterprise para aceder a esta funcionalidade",
    "ReportPortalInfo_UpgradeTo_Enterprise_MST": "Atualização para CXA Advanced para aceder a esta funcionalidade",
    "ReportPortalInfo_UpgradeTo_Call Centre Supervisor": "Atualização para Supervisor do centro de atendimento para aceder a esta funcionalidade",
    "ReportPortalInfo_UpgradeTo_Call Centre Supervisor_MST": "Atualização para o CXE Advanced para aceder a esta funcionalidade",
    "NAME": "ReportPortalInfo"
}